import * as AT from "src/core/users/store/users.constants";
import { IUser } from "src/core/users/api/users.api";

export type UserActions = ISetUser | IPurgeUsers;

interface ISetUser {
  type: AT.SET_USER;
  user: IUser | null;
}

export const setUser = (user: IUser | null): ISetUser => {
  return {
    type: AT.SET_USER,
    user
  };
};

interface IPurgeUsers {
  type: AT.PURGE_USERS;
}

export const purgeUsers = (): IPurgeUsers => {
  return { type: AT.PURGE_USERS };
};
